import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import startCase from 'lodash/startCase';
import { maskPhone } from 'common/helpers/mask-phone';
import { dayFormatType, formatDay } from 'common/helpers/day';
import { getCountryFromCode } from 'common/helpers/country';
import SpinLoading from 'common/components/spin-loading';
import event from '~helpers/mixpanel';
import { pageType } from '~constants/pages';

const StudentInfo = ({ loading, student }) => {
  const { t } = useTranslation();
  const { fullName, emailAddress, registeredPhone, sourceCountry, createdAt, updatedAt, id } =
    student || {};

  useEffect(() => {
    if (!id || !fullName) return;
    event('Viewed Student Details Page', {
      'Student ID': id,
      'Student Name': startCase(fullName),
      'Current Page Type': pageType.studentDetailPage,
    });
  }, [id, fullName]);

  if (loading) return <SpinLoading className="student-info__loading" />;

  return (
    <div className="student-info">
      <h2 className="student-info__full-name">{startCase(fullName)}</h2>
      <div className="student-info__details">
        <div className="student-info__detail">
          <span className="student-info__label">{t('cms:cms.students.detail.student_name')}</span>
          <span className="student-info__value">{startCase(fullName) || '-'}</span>
        </div>
        <div className="student-info__detail">
          <span className="student-info__label">{t('cms:cms.students.detail.email')}</span>
          <span className="student-info__value">{emailAddress || '-'}</span>
        </div>
        <div className="student-info__detail">
          <span className="student-info__label">{t('cms:cms.students.detail.phone_number')}</span>
          <span className="student-info__value">{maskPhone(registeredPhone) || '-'}</span>
        </div>
        <div className="student-info__detail">
          <span className="student-info__label">{t('cms:cms.students.detail.source_country')}</span>
          <span className="student-info__value">{getCountryFromCode(sourceCountry)}</span>
        </div>
        <div className="student-info__detail">
          <span className="student-info__label">{t('cms:cms.students.detail.create_date')}</span>
          <span className="student-info__value">
            {formatDay(dayFormatType.UKWITHHM, createdAt) || '-'}
          </span>
        </div>
        <div className="student-info__detail">
          <span className="student-info__label">{t('cms:cms.students.detail.update_date')}</span>
          <span className="student-info__value">
            {formatDay(dayFormatType.UKWITHHM, updatedAt) || '-'}
          </span>
        </div>
      </div>
    </div>
  );
};
export default StudentInfo;
